import {ObjectUtil} from '../../util/object-util';

export class Partner {

  partnerId: string = null;
  userIds: string[] = [];
  name: string = null;
  street: string = null;
  houseNumber: string = null;
  postalCode: string = null;
  location: string = null;
  countryCode: string = null;
  countryName: string = null;
  addressSupplement: string = null;
  companyId: string = null;

  constructor(object?: Object) {
    ObjectUtil.assign(this, object);
  }
}
